import { stringMaxLength } from "@/assets/validation/common";
import ListItemNumberModel from "@/models/listItemNumberModel";
import ContractorContactPersonRestModel from "@/models/rest/contractor/contractorContactPersonRestModel";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import VForm from "../../../models/v-form";

@Component
export default class ContractorContactPersonDialog extends Vue {
    validation = {
        firstAndLastName: [stringMaxLength(this.$i18n, this.$t("contractor.employeName"), 75), (value: string) => !!value || this.$t("common.validationErrorRequired")],
        email: [stringMaxLength(this.$i18n, this.$t("contractor.email"), 150)],
        position: [stringMaxLength(this.$i18n, this.$t("contractor.telephone"), 150)],
        telephone: [stringMaxLength(this.$i18n, this.$t("contractor.telephone"), 150)],
        role: [(value: string) => !!value || this.$t("common.validationErrorRequired")]
    };

    updated() {
        this.$nextTick(function () {
            if (this.$refs.form != undefined) {
                (this.$refs.form as VForm).resetValidation();
            }
        });
    }

    get contactPerson(): ContractorContactPersonRestModel {
        return this.$store.direct.state.contractor.contactPerson;
    }

    set contactPerson(val: ContractorContactPersonRestModel) {
        this.$store.direct.commit.contractor.setContactPerson(val);
    }

    get roleListSorted(): ListItemNumberModel[] {
        return this.$store.direct.state.contractor.contractorAssets.personRoles;
    }

    get showDialog(): boolean {
        return this.$store.direct.state.supervisor.showContractorContactPersonDialog;
    }

    async saveClick(): Promise<void> {
        if ((this.$refs.form as VForm).validate()) {
            await this.$store.direct.dispatch.contractor.saveContactPerson({ loadContactPersonList: false });
            await this.$store.direct.dispatch.supervisor.isConfirmedContractorContactPersonDialog();
            this.contactPerson = {} as ContractorContactPersonRestModel
        }
    }

    closeClick(): void {
        this.$store.direct.dispatch.supervisor.isNotConfirmedContractorContactPersonDialog();
        this.contactPerson = {} as ContractorContactPersonRestModel
    }
}
